import { getSavedFormReferrer, deleteSavedReferrer } from './components/forms/helpers'
document.addEventListener('DOMContentLoaded', () => {
  const formReturnLink = document.querySelector('[data-form-back-link]')
  const savedReferrer = getSavedFormReferrer()
  if (formReturnLink && savedReferrer) {
    deleteSavedReferrer()
    formReturnLink.setAttribute('href', savedReferrer)
  }
})
